// Utility function to detect language from skills tested array
export const getLanguageFromSkills = (skillsTested) => {
  if (!skillsTested || skillsTested.length === 0) return 'javascript';
  
  const skillsLower = skillsTested.map(skill => skill.toLowerCase());
  
  // Map common skills to Monaco Editor language identifiers
  if (skillsLower.includes('html')) return 'html';
  if (skillsLower.includes('css')) return 'css';
  if (skillsLower.includes('javascript') || skillsLower.includes('js')) return 'javascript';
  if (skillsLower.includes('typescript') || skillsLower.includes('ts')) return 'typescript';
  if (skillsLower.includes('python') || skillsLower.includes('py')) return 'python';
  if (skillsLower.includes('java')) return 'java';
  if (skillsLower.includes('c#') || skillsLower.includes('csharp')) return 'csharp';
  if (skillsLower.includes('c++') || skillsLower.includes('cpp')) return 'cpp';
  if (skillsLower.includes('c')) return 'c';
  if (skillsLower.includes('php') || skillsLower.includes('wordpress')) return 'php';
  if (skillsLower.includes('ruby')) return 'ruby';
  if (skillsLower.includes('go') || skillsLower.includes('golang')) return 'go';
  if (skillsLower.includes('rust')) return 'rust';
  if (skillsLower.includes('swift')) return 'swift';
  if (skillsLower.includes('objective-c') || skillsLower.includes('objective c') || skillsLower.includes('objc') || skillsLower.includes('obj-c')) return 'objective-c';
  if (skillsLower.includes('kotlin')) return 'kotlin';
  if (skillsLower.includes('scala')) return 'scala';
  if (skillsLower.includes('r')) return 'r';
  if (skillsLower.includes('dart')) return 'dart';
  if (skillsLower.includes('perl')) return 'perl';
  if (skillsLower.includes('haskell')) return 'haskell';
  if (skillsLower.includes('lua')) return 'lua';
  if (skillsLower.includes('sql')) return 'sql';
  if (skillsLower.includes('shell') || skillsLower.includes('bash')) return 'shell';
  if (skillsLower.includes('powershell')) return 'powershell';
  if (skillsLower.includes('yaml') || skillsLower.includes('aws') || skillsLower.some(skill => skill.includes('github actions'))) return 'yaml';
  if (skillsLower.includes('json')) return 'json';
  if (skillsLower.includes('markdown') || skillsLower.includes('md')) return 'markdown';
  if (skillsLower.includes('xml')) return 'xml';
  if (skillsLower.includes('graphql')) return 'graphql';
  if (skillsLower.includes('elixir')) return 'elixir';
  if (skillsLower.includes('clojure')) return 'clojure';
  
  // .NET and Microsoft languages
  if (skillsLower.includes('f#') || skillsLower.includes('fsharp')) return 'fsharp';
  if (skillsLower.includes('visual basic') || skillsLower.includes('vb') || skillsLower.includes('vbscript')) return 'vb';
  
  // Blockchain and smart contracts
  if (skillsLower.includes('solidity') || skillsLower.includes('sol')) return 'sol';
  
  // Scientific and data languages
  if (skillsLower.includes('julia')) return 'julia';
  if (skillsLower.includes('fortran')) return 'fortran';
  if (skillsLower.includes('matlab')) return 'matlab';
  
  // Enterprise and business languages
  if (skillsLower.includes('apex') || skillsLower.includes('salesforce')) return 'apex';
  if (skillsLower.includes('abap') || skillsLower.includes('sap')) return 'abap';
  if (skillsLower.includes('cobol')) return 'cobol';
  
  // Database languages
  if (skillsLower.includes('mysql')) return 'mysql';
  if (skillsLower.includes('postgresql') || skillsLower.includes('postgres') || skillsLower.includes('pgsql')) return 'pgsql';
  if (skillsLower.includes('redis')) return 'redis';
  
  // Functional and academic languages
  if (skillsLower.includes('ocaml')) return 'ocaml';
  if (skillsLower.includes('erlang')) return 'erlang';
  if (skillsLower.includes('scheme')) return 'scheme';
  if (skillsLower.includes('prolog')) return 'prolog';
  
  // Systems and low-level languages
  if (skillsLower.includes('assembly') || skillsLower.includes('asm') || skillsLower.includes('x86') || skillsLower.includes('arm')) return 'asm';
  if (skillsLower.includes('pascal')) return 'pascal';
  if (skillsLower.includes('ada')) return 'ada';
  
  // Scripting languages
  if (skillsLower.includes('batch') || skillsLower.includes('bat')) return 'bat';
  
  // Additional languages
  if (skillsLower.includes('dockerfile') || skillsLower.includes('docker')) return 'dockerfile';
  if (skillsLower.includes('docker-compose')) return 'yaml';
  // Terraform/HCL - Monaco doesn't have native support, use 'hcl' if available, otherwise fallback to a similar language
  if (skillsLower.includes('terraform') || skillsLower.includes('tf') || skillsLower.includes('hcl')) return 'hcl';
  if (skillsLower.includes('toml')) return 'toml';
  if (skillsLower.includes('ini')) return 'ini';
  if (skillsLower.includes('csv')) return 'csv';
  if (skillsLower.includes('protobuf') || skillsLower.includes('proto')) return 'proto';
  if (skillsLower.includes('scss') || skillsLower.includes('sass')) return 'scss';
  if (skillsLower.includes('jsx')) return 'jsx';
  if (skillsLower.includes('tsx')) return 'tsx';
  if (skillsLower.includes('vue')) return 'vue';
  if (skillsLower.includes('angular')) return 'html';
  if (skillsLower.includes('svelte')) return 'svelte';
  if (skillsLower.includes('groovy') || skillsLower.includes('jenkins') || skillsLower.includes('jenkinsfile')) return 'groovy';
  if (skillsLower.includes('makefile')) return 'makefile';
  
  // Default to javascript if no match is found
  return 'javascript';
};

// Language display names for UI dropdowns
export const languageDisplayNames = {
  'javascript': 'JavaScript',
  'typescript': 'TypeScript',
  'html': 'HTML',
  'css': 'CSS',
  'python': 'Python',
  'java': 'Java',
  'csharp': 'C#',
  'cpp': 'C++',
  'c': 'C',
  'php': 'PHP',
  'ruby': 'Ruby',
  'go': 'Go',
  'rust': 'Rust',
  'swift': 'Swift',
  'objective-c': 'Objective-C',
  'kotlin': 'Kotlin',
  'scala': 'Scala',
  'r': 'R',
  'dart': 'Dart',
  'perl': 'Perl',
  'haskell': 'Haskell',
  'lua': 'Lua',
  'sql': 'SQL',
  'shell': 'Shell/Bash',
  'powershell': 'PowerShell',
  'yaml': 'YAML',
  'json': 'JSON',
  'markdown': 'Markdown',
  'xml': 'XML',
  'graphql': 'GraphQL',
  'elixir': 'Elixir',
  'clojure': 'Clojure',
  'fsharp': 'F#',
  'vb': 'Visual Basic',
  'sol': 'Solidity',
  'julia': 'Julia',
  'fortran': 'Fortran',
  'matlab': 'MATLAB',
  'apex': 'Apex (Salesforce)',
  'abap': 'ABAP (SAP)',
  'cobol': 'COBOL',
  'mysql': 'MySQL',
  'pgsql': 'PostgreSQL',
  'redis': 'Redis',
  'ocaml': 'OCaml',
  'erlang': 'Erlang',
  'scheme': 'Scheme',
  'prolog': 'Prolog',
  'asm': 'Assembly',
  'pascal': 'Pascal',
  'ada': 'Ada',
  'bat': 'Batch',
  'dockerfile': 'Dockerfile',
  'hcl': 'Terraform/HCL',
  'toml': 'TOML',
  'ini': 'INI',
  'csv': 'CSV',
  'proto': 'Protocol Buffers',
  'scss': 'SCSS/SASS',
  'jsx': 'JSX',
  'tsx': 'TSX',
  'vue': 'Vue',
  'svelte': 'Svelte',
  'groovy': 'Groovy',
  'makefile': 'Makefile'
};
